import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import {
  MicOnIcon,
  MicOffIcon,
  CamOnIcon,
  CamOffIcon,
} from '../MeetingIcons';
import {
  BadgesWrap,
  StatusBadge,
  StatusIcon,
  IconBadgeButton,
} from './style';

const renderBadge = (tone, icon, label) => (
  <StatusBadge $tone={tone}>
    <StatusIcon aria-hidden="true">{icon}</StatusIcon>
    {label}
  </StatusBadge>
);

const renderIconBadge = (tone, icon, label) => (
  <IconBadgeButton $tone={tone} title={label} aria-label={label}>
    <StatusIcon aria-hidden="true">{icon}</StatusIcon>
  </IconBadgeButton>
);

const ParticipantStatusBadges = ({
  attendeeId,
  joined,
  iconOnly = false,
  showLabels = true,
  showOnlyMutedMic = false,
  showOnlyMic = false,
  providedMuted,
  providedVideoEnabled,
  preferProvidedStatus = false,
}) => {
  const { t } = useTranslation();
  const hookStatus = useAttendeeStatus(attendeeId || '');
  const muted = (preferProvidedStatus || !attendeeId) && typeof providedMuted === 'boolean'
    ? providedMuted
    : (hookStatus?.muted ?? false);
  const videoEnabled = (preferProvidedStatus || !attendeeId) && typeof providedVideoEnabled === 'boolean'
    ? providedVideoEnabled
    : (hookStatus?.videoEnabled ?? false);
  const micLabel = muted ? t('VideoChatV2.audio.muted') : t('VideoChatV2.audio.on');
  const camLabel = videoEnabled ? t('VideoChatV2.camera.on') : t('VideoChatV2.camera.off');

  if (!joined) {
    return null;
  }

  if (showOnlyMutedMic) {
    if (!muted) {
      return null;
    }

    return (
      <BadgesWrap>
        {(iconOnly || !showLabels)
          ? renderIconBadge('warn', <MicOffIcon />, micLabel)
          : renderBadge('warn', <MicOffIcon />, micLabel)}
      </BadgesWrap>
    );
  }

  if (showOnlyMic) {
    return (
      <BadgesWrap>
        {(iconOnly || !showLabels)
          ? renderIconBadge(muted ? 'warn' : 'ok', muted ? <MicOffIcon /> : <MicOnIcon />, micLabel)
          : renderBadge(muted ? 'warn' : 'ok', muted ? <MicOffIcon /> : <MicOnIcon />, micLabel)}
      </BadgesWrap>
    );
  }

  return (
    <BadgesWrap>
      {(iconOnly || !showLabels)
        ? renderIconBadge(muted ? 'warn' : 'ok', muted ? <MicOffIcon /> : <MicOnIcon />, micLabel)
        : renderBadge(muted ? 'warn' : 'ok', muted ? <MicOffIcon /> : <MicOnIcon />, micLabel)}
      {(iconOnly || !showLabels)
        ? renderIconBadge(videoEnabled ? 'ok' : 'warn', videoEnabled ? <CamOnIcon /> : <CamOffIcon />, camLabel)
        : renderBadge(videoEnabled ? 'ok' : 'warn', videoEnabled ? <CamOnIcon /> : <CamOffIcon />, camLabel)}
    </BadgesWrap>
  );
};

export default ParticipantStatusBadges;